/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import TransactionContainer from './dashboard/TransactionsContainer';
import CashInsContainer from './transaction/container/CashInsContainer';

function CashInContainer({ match }) {
  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">Cash-In Transactions</div>
        <div className="generic-module-nav mb-3">
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/cash-in"
          >
            Dashboard
          </NavLink>
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/cash-in/transaction"
          >
            Transaction
          </NavLink>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            component={TransactionContainer}
          />
          <Route
            path={`${match.path}/transaction`}
            component={CashInsContainer}
          />
        </Switch>
      </div>
    </>
  );
}

CashInContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(CashInContainer);
